"use client";

import { usePathname } from 'next/navigation';
import { Row, Col } from 'antd';
import ReactMarkdown from "react-markdown";
import { CSS_HELPERS, MEDIA_SCREENS, THEME_COLORS } from '@theme/constants';
import styled from 'styled-components';
import _ from 'lodash';
import BoxUi from '@components/common/BoxUi';
import TitleUi from '@components/common/TitleUi';
import Subcategorias from './subcategorias';
import AccesosDirectos from './accesosDirectos';
import Caracteristicas from './caracteristicas';
import Detalles from './detalles';
import Historias from './Historias';
import AdjuntosProfile from './AdjuntosProfile';
import IndicadorRentabilidad from '@components/home/indicadores2/IndicadorRentabilidad';
import IndicadorGlobal from '@components/home/indicadores2/IndicadorGlobal';
import ComposicionPortafolios from '@components/home/indicadores2/ComposicionPortafolios';
import Link from 'next/link';
import SimuladorButton from './SimuladorButton';
import LineBreaker from '@components/common/LineBreaker';
import Image from 'next/legacy/image';
// import Bolder from '@components/common/Bolder';

const handleFiguras = (fiugraId) => {
	const aux = fiugraId
		? `${process.env.API_URL}/figuras/${fiugraId}.webp`
		: '/img/placeholder.png';
	return aux;
}

const parseDescripcion = (descripcion) => {
	if (!descripcion) return false;
	if (descripcion.length) {
		const parts = descripcion.split("");

		const url_blocks = [];
		const leastText = [];
		const link = [];
		const text = [];

		parts.forEach((element, posiiton) => {
			if (element === "[" || element === "]") url_blocks.push(posiiton);
		});
		if (url_blocks.length == 0) return false;
		parts.forEach((element, positon) => {
			if (
				element !== "["
				&& element !== "]"
				&& positon >= 0
				&& positon <= url_blocks[0]
			) {
				leastText.push(element);
			}
		});
		for (let i = url_blocks[0] + 1; i < url_blocks[1]; i++) {
			text.push(parts[i]);
		}
		for (let i = url_blocks[2] + 1; i < url_blocks[3]; i++) {
			link.push(parts[i]);
		}
		const payload = {
			text: text.join(""),
			link: link.join(""),
			least: leastText.join(""),
			url_blocks,
			descripcion
		}
		return payload;
	}
	return false;
}


const CategoriaProfile = ({ entrada = {}, indicadores }) => {
	const { figuraId2, titulo, descripcion_larga, slug, detalles, caracteristicas, vista, carnada } = entrada;

	const entradas = entrada?.entradas && entrada?.entradas?.length ? entrada.entradas : [];


	const subcategorias = entradas.filter(item => !item.acceso_directo);
	const accesos_directos = entradas.filter(item => item.acceso_directo);
	console.log({ subcategorias, accesos_directos });
	// const dispatch = useDispatch();
	// const router = useRouter();
	const pathname = usePathname();

	const figuraPortada = handleFiguras(figuraId2);

	const customParts = parseDescripcion(descripcion_larga);

	if (indicadores && indicadores.id) {
		return (
			<>
				<IndicadorRentabilidad data={indicadores} />
				{/* <ComposicionPortafolios /> */}
				<IndicadorGlobal data={indicadores} />
			</>
		)
	}
	return (
		<View>
			<BoxUi>
				<Row gutter={[30, 15]}>
					<Col xs={24} sm={12} >
						<div className="picContainer">
							{/* <img
								className="pic"
								src={`/figuras/${figuraId2}.webp`}
								alt="Genesis"
							/> */}
							<Image
								alt="Genesis"
								src={`/figuras/${figuraId2}.webp`}
								layout="responsive"
								objectFit="cover"
								// width={1200 / 2}
								// height={450 / 2}
								className='pic'
								quality={100}
								unoptimized={true}
							/>

							<div className="picOverlay" />
						</div>
					</Col>
					<Col xs={24} sm={10}  >
						<Row gutter={[15, 15]} style={{ background: '', height: '100%' }} >
							<Col xs={24}>
								<Row gutter={[15, 15]}>
									<Col xs={24}>
										<TitleUi
											titulo={titulo}
											noMarginX
											variant={(['categorías'].find(item => item === vista)) ? "color_box" : ''}
										/>
									</Col>
									<Col xs={24} >
										{
											customParts ?
												<ReactMarkdown
													className='markdown-entradas'
												>
													{descripcion_larga}
												</ReactMarkdown>
												// <Bolder 
												// 	titulo={
												// 		<p>
												// 			{customParts.least}
												// 			<span>
												// 				<Link href={customParts.link}>
												// 					<a className='light_primary_main'>
												// 						{customParts.text}
												// 					</a>
												// 				</Link>
												// 			</span>
												// 		</p>
												// 	}
												// />
												:
												<LineBreaker titulo={descripcion_larga} boldColor={THEME_COLORS.light.primary.alt} lineHeight={1.7} />

										}
									</Col>
								</Row>
							</Col>


							<Col xs={24}>
								<div
									style={{
										height: "100%",
										display: "flex",
										flexDirection: "column",
										justifyContent: "space-between",
									}}
								>
									<div>
										<Caracteristicas data={caracteristicas} />
									</div>
									{
										(slug === 'rentaplus' ||
											slug === 'estrategico' ||
											slug === 'superior' ||
											slug === 'eficaz' ||
											slug === 'master') ?
											<div xs={24}
												style={{
													display: 'flex',
													flexDirection: 'column',
													justifyContent: 'flex-end',
												}} >
												{/* <p
													className="sm strong600"
													style={{
														color: THEME_COLORS.light.text.paragraph,
													}}>
													*Tasas de rentabilidad variable Vigente al {pathname?.includes('inversion') ? '01-07-2024' : '30-06-2022'}.
												</p> */}
											</div>
											: null
									}
								</div>
							</Col>


						</Row>
					</Col>


				</Row>
			</BoxUi>
			{
				pathname?.includes('normativas') ||
					pathname?.includes('descargas')
					? <BoxUi background> <AdjuntosProfile filter={slug} /></BoxUi>
					: null
			}


			<Detalles data={detalles} />

			<BoxUi background hide={!subcategorias.length}>
				<TitleUi titulo={carnada} h2 />
				<Subcategorias data={subcategorias} preSlug={slug} />
			</BoxUi>

			{/* {
				vista === 'servicios'

				&& <BoxUi background>
					<Row gutter={[16, 16]}>
						<Col xs={24} align="middle">
							<SimuladorButton slug={slug} />
						</Col>
					</Row>


				</BoxUi>


			} */}




			<BoxUi hide={!accesos_directos.length}>
				<TitleUi titulo="Enlaces Rápidos" h2 />
				<AccesosDirectos data={accesos_directos} />
			</BoxUi>
			<BoxUi center>
				{
					pathname?.includes('inversion') &&
					<Historias />
				}
			</BoxUi>
		</View>
	);
}

export default CategoriaProfile;


///:: CARACTERISTICAS

const View = styled.div`
 
    .titulo_box {
        display: flex;
        h2{
            overflow: hidden;
            border-radius: ${CSS_HELPERS.RADIUS};
            border-top-right-radius: 200px;
            color:${THEME_COLORS.light.primary.contrastText};
            background-color:${THEME_COLORS.light.primary.alt};
            padding: .3em;
            padding-right: 3em;
           ${CSS_HELPERS.BORDER_LINE_BOTTOM}
        }
    };

    .categoria_descripcion_box{
        height: 15em;
        padding: 1em 0;
    }

    .picContainer{
        border-radius: 0 20pt 20pt 0;
        height: 33em;
        overflow: hidden;
        position:relative ;
        @media screen and  (min-width: ${0}px) and (max-width: ${MEDIA_SCREENS.XS}px) { 
        width:100%;
        }
        @media screen and  (min-width: ${MEDIA_SCREENS.XS}px) and (max-width: ${MEDIA_SCREENS.SM}px) { 
        width:100%;
        }
        @media screen and  (min-width: ${MEDIA_SCREENS.SM}px) and (max-width: ${MEDIA_SCREENS.MD}px) { 
        width:100%;
        }
        @media screen and  (min-width: ${MEDIA_SCREENS.MD}px) and (max-width: ${MEDIA_SCREENS.LG}px) { 
        width:100%;
        }
        .picOverlay{
            width:100% ;
            height: 33em;
            position:absolute;
            z-index:3;
            top:0;
            /* background: linear-gradient(90deg, #FFFFFF85 12%, #FFFFFF00 60%); */
            border-bottom: .6em solid ${THEME_COLORS.light.secondary.main};
            border-radius:0 20pt 20pt 0;

        }
        .pic{
            object-fit:cover;
            width:100%; 
            border-radius:0 20pt 20pt 0 ;
            overflow:hidden ;
            max-width:100%;
            width:100%;
            height:100%;
        }


    }
`